import React from "react";
import "./PrivacyPolicy.css";

const PrivacyPolicy = () => {
  return (
    <section className="bi-privacy">

      {/* HERO */}
      <div className="bi-privacy-hero">
        <div className="bi-privacy-container">

          <div className="bi-privacy-hero-content">

            <div className="bi-privacy-label">
              BEST INDUSTRIES / LEGAL
            </div>

            <h1>
              Privacy
              <span> Policy</span>
            </h1>

            <p>
              Your privacy matters to us. Learn how Best Industries
              collects, uses and protects information provided by
              clients and website visitors.
            </p>

          </div>

          <div className="bi-privacy-hero-mark">
            <div className="bi-privacy-lock">
              <span>◆</span>
            </div>

            <strong>DATA</strong>
            <small>PROTECTION & TRUST</small>
          </div>

        </div>
      </div>


      {/* MAIN */}
      <div className="bi-privacy-container">

        <div className="bi-privacy-layout">

          {/* SIDEBAR */}
          <aside className="bi-privacy-sidebar">

            <div className="bi-privacy-sidebar-title">
              PRIVACY
              <span>CONTENTS</span>
            </div>

            <a href="#introduction">01 / Introduction</a>
            <a href="#personal-data">02 / Personal Data</a>
            <a href="#usage">03 / Use of Information</a>
            <a href="#automatic">04 / Automatic Data</a>
            <a href="#mobile">05 / Mobile Information</a>
            <a href="#types">06 / Data Collected</a>
            <a href="#why">07 / Why We Collect</a>
            <a href="#cookies">08 / Cookie Policy</a>
            <a href="#cookie-types">09 / Cookie Types</a>
            <a href="#security">10 / Data Security</a>
            <a href="#children">11 / Children's Policy</a>

          </aside>


          {/* CONTENT */}
          <main className="bi-privacy-content">

            {/* INTRODUCTION */}
            <article
              id="introduction"
              className="bi-privacy-article"
            >

              <div className="bi-privacy-heading">
                <span>01</span>
                <h2>Introduction</h2>
              </div>

              <p>
                This Privacy Policy will help you understand how
                Best Industries maintains and protects the data
                provided by our clients and users.
              </p>

              <p>
                We advise visitors to frequently visit this page
                for updates. Best Industries is committed to
                securing your data and keeping it safe.
              </p>

              <p>
                Best Industries has taken appropriate measures to
                prevent data theft, unauthorized access and
                disclosure by implementing suitable technologies
                and security practices to safeguard the information
                we collect.
              </p>

              <p>
                We protect the information that you provide to us
                and make reasonable efforts to maintain its security.
              </p>

              <div className="bi-privacy-highlight">

                <div className="bi-privacy-highlight-icon">
                  ✓
                </div>

                <div>
                  <strong>
                    YOUR PRIVACY IS IMPORTANT
                  </strong>

                  <p>
                    We are committed to protecting the information
                    entrusted to Best Industries.
                  </p>
                </div>

              </div>

            </article>


            {/* PERSONAL DATA */}
            <article
              id="personal-data"
              className="bi-privacy-article"
            >

              <div className="bi-privacy-heading">
                <span>02</span>
                <h2>Personal Information</h2>
              </div>

              <p>
                Best Industries values your privacy. This Privacy
                Policy describes how Best Industries collects,
                uses and handles personal information obtained
                from visitors to our website.
              </p>

              <p>
                Personal information means information that may
                identify an individual. This may include:
              </p>

              <div className="bi-privacy-data-grid">

                <div>
                  <span>01</span>
                  <strong>Name</strong>
                </div>

                <div>
                  <span>02</span>
                  <strong>Email Address</strong>
                </div>

                <div>
                  <span>03</span>
                  <strong>Phone Number</strong>
                </div>

                <div>
                  <span>04</span>
                  <strong>Password</strong>
                </div>

              </div>

            </article>


            {/* USE */}
            <article
              id="usage"
              className="bi-privacy-article"
            >

              <div className="bi-privacy-heading">
                <span>03</span>
                <h2>How We Use Your Information</h2>
              </div>

              <p>
                When you use our products or services, Best
                Industries may collect personal information from
                visitors.
              </p>

              <p>
                We may use this information for communicating
                with you, providing updates, keeping you connected
                with the company and for promotional purposes.
              </p>

              <p>
                We collect personal information where necessary
                to allow you to use certain features of our website
                and services.
              </p>

              <p>
                When Best Industries collects personal data, we
                aim to provide appropriate information describing
                what information is collected and how it may be
                used.
              </p>

              <p>
                We will only collect information that is reasonably
                needed for identification or service-related
                purposes and will take reasonable steps to ensure
                that the information provided is accurate.
              </p>

              <p>
                Best Industries will make reasonable efforts to
                protect your information and will not share your
                personal information with third parties except
                where required or permitted for legitimate purposes.
              </p>

            </article>


            {/* AUTOMATIC */}
            <article
              id="automatic"
              className="bi-privacy-article"
            >

              <div className="bi-privacy-heading">
                <span>04</span>
                <h2>Automatically Collected Information</h2>
              </div>

              <p>
                Our primary goal in collecting information is to
                provide and improve our services, communicate with
                visitors and make our website easier to navigate.
              </p>

              <p>
                When you visit the Best Industries website, some
                information may be automatically collected.
              </p>

              <div className="bi-privacy-tech-grid">

                <div>
                  <span>DEVICE</span>
                  <strong>Operating System</strong>
                </div>

                <div>
                  <span>NETWORK</span>
                  <strong>IP Address</strong>
                </div>

                <div>
                  <span>ACCESS</span>
                  <strong>Access Time</strong>
                </div>

                <div>
                  <span>BROWSER</span>
                  <strong>Browser Type</strong>
                </div>

                <div>
                  <span>LANGUAGE</span>
                  <strong>Browser Language</strong>
                </div>

                <div>
                  <span>ACTIVITY</span>
                  <strong>Website Usage</strong>
                </div>

              </div>

              <p>
                Best Industries may also collect information about
                visitor usage and activity on our website to improve
                our site and services, understand visitor preferences,
                analyze website usage, respond to enquiries and
                communicate information about promotions, events,
                products and services.
              </p>

            </article>


            {/* MOBILE */}
            <article
              id="mobile"
              className="bi-privacy-article"
            >

              <div className="bi-privacy-heading">
                <span>05</span>
                <h2>Mobile Device Information</h2>
              </div>

              <p>
                When you access Best Industries services using a
                mobile device, we may collect certain technical
                information about that device.
              </p>

              <div className="bi-privacy-list-box">

                <div>
                  <i>01</i>
                  Type of mobile device
                </div>

                <div>
                  <i>02</i>
                  Mobile device unique ID
                </div>

                <div>
                  <i>03</i>
                  IP address of the mobile device
                </div>

                <div>
                  <i>04</i>
                  Mobile operating system
                </div>

                <div>
                  <i>05</i>
                  Mobile internet browser
                </div>

                <div>
                  <i>06</i>
                  Unique device identifier
                </div>

                <div>
                  <i>07</i>
                  Other relevant technical data
                </div>

                <div>
                  <i>08</i>
                  Location information

                </div>

              </div>

            </article>


            {/* TYPES */}
            <article
              id="types"
              className="bi-privacy-article"
            >

              <div className="bi-privacy-heading">
                <span>06</span>
                <h2>Types of Data Collected</h2>
              </div>

              <p>
                While using our services, we may ask users to
                provide certain personal information.
              </p>

              <div className="bi-privacy-collected">

                <div className="bi-privacy-collected-main">

                  <span>PERSONAL DATA</span>

                  <h3>
                    Information provided by users
                  </h3>

                  <ul>
                    <li>Name of the user</li>
                    <li>Email address</li>
                    <li>Postal address</li>
                    <li>PIN code</li>
                    <li>Other information that may directly or
                      indirectly identify the user</li>
                  </ul>

                </div>

                <div className="bi-privacy-collected-side">

                  <div>
                    <strong>COLLECT</strong>
                    <span>Relevant information</span>
                  </div>

                  <div>
                    <strong>PROTECT</strong>
                    <span>Safeguarded information</span>
                  </div>

                  <div>
                    <strong>IMPROVE</strong>
                    <span>Better user experience</span>
                  </div>

                </div>

              </div>

              <p>
                Best Industries collects various types of user
                information where necessary to provide and improve
                our services to users.
              </p>

            </article>


            {/* WHY */}
            <article
              id="why"
              className="bi-privacy-article"
            >

              <div className="bi-privacy-heading">
                <span>07</span>
                <h2>Why We Collect Your Information</h2>
              </div>

              <div className="bi-privacy-reasons">

                <div>
                  <b>01</b>
                  <strong>
                    Understand User Needs
                  </strong>
                  <p>
                    To better understand the needs and preferences
                    of our users.
                  </p>
                </div>

                <div>
                  <b>02</b>
                  <strong>
                    Upgrade Our Services
                  </strong>
                  <p>
                    To improve and develop our website, products
                    and services.
                  </p>
                </div>

                <div>
                  <b>03</b>
                  <strong>
                    Keep Users Updated
                  </strong>
                  <p>
                    To communicate important information, updates
                    and relevant company news.
                  </p>
                </div>

              </div>

            </article>


            {/* COOKIE POLICY */}
            <article
              id="cookies"
              className="bi-privacy-article"
            >

              <div className="bi-privacy-heading">
                <span>08</span>
                <h2>Our Cookie Policy</h2>
              </div>

              <p>
                Once you agree to allow our website to use cookies,
                you also agree to the collection of information
                through those cookies.
              </p>

              <p>
                The information collected through cookies may be
                used to improve our services and enhance the website
                experience for users.
              </p>

              <p>
                Best Industries does not sell, trade or otherwise
                transfer personal information to outside parties.
              </p>

              <p>
                We may use cookies and other tracking technologies
                to understand the usage of our services and retain
                certain information. Other tracking technologies
                may include beacons, scripts and tags.
              </p>

              <div className="bi-privacy-cookie-warning">

                <span>COOKIE CONTROL</span>

                <p>
                  If visitors do not accept cookies, some parts
                  of our services may not function or may not be
                  fully accessible.
                </p>

              </div>

            </article>


            {/* COOKIE TYPES */}
            <article
              id="cookie-types"
              className="bi-privacy-article"
            >

              <div className="bi-privacy-heading">
                <span>09</span>
                <h2>Types of Cookies</h2>
              </div>


              {/* SESSION */}
              <div className="bi-cookie-card">

                <div className="bi-cookie-number">
                  01
                </div>

                <div>
                  <h3>Session Cookies</h3>

                  <p>
                    Session cookies are also called memory cookies,
                    transient cookies or non-persistent cookies.
                    They exist in temporary memory and are not
                    retained after the browser is closed.
                  </p>

                  <p>
                    These cookies usually store information such
                    as session identification and do not personally
                    identify the user.
                  </p>
                </div>

              </div>


              {/* PERMANENT */}
              <div className="bi-cookie-card">

                <div className="bi-cookie-number">
                  02
                </div>

                <div>
                  <h3>Permanent Cookies</h3>

                  <p>
                    Permanent cookies are stored on the user's
                    device and may help remember information,
                    settings and sign-in details previously saved
                    by the user.
                  </p>

                  <p>
                    These cookies have an expiry date and may be
                    used for purposes such as authentication and
                    remembering a user's login state.
                  </p>

                  <p>
                    Permanent cookies are also known as persistent
                    cookies and may use unique identifiers.
                  </p>
                </div>

              </div>


              {/* THIRD PARTY */}
              <div className="bi-cookie-card">

                <div className="bi-cookie-number">
                  03
                </div>

                <div>
                  <h3>Third-Party Cookies</h3>

                  <p>
                    Third-party cookies may allow external
                    advertisers and service providers to track
                    users across websites and provide advertising
                    or analytics.
                  </p>

                  <p>
                    These cookies may be set by a third-party
                    server. Advertisers, marketers and social
                    media platforms may use this type of technology.
                  </p>
                </div>

              </div>


              {/* FLASH */}
              <div className="bi-cookie-card">

                <div className="bi-cookie-number">
                  04
                </div>

                <div>
                  <h3>Flash Cookies</h3>

                  <p>
                    Flash cookies, also known as Local Shared
                    Objects, are stored by applications using
                    Adobe Flash technology and may need to be
                    removed separately through the relevant
                    application settings.
                  </p>
                </div>

              </div>


              {/* ZOMBIE */}
              <div className="bi-cookie-card">

                <div className="bi-cookie-number">
                  05
                </div>

                <div>
                  <h3>Zombie Cookies</h3>

                  <p>
                    Zombie cookies are technologies designed to
                    recreate or retain information after a user
                    attempts to remove a cookie. They may be used
                    for online tracking and marketing purposes.
                  </p>
                </div>

              </div>


              <div className="bi-privacy-cookie-control">

                <div className="bi-privacy-cookie-icon">
                  ⚙
                </div>

                <div>

                  <strong>
                    MANAGING YOUR COOKIES
                  </strong>

                  <p>
                    You can disable cookies by changing the
                    settings of your internet browser. Please note
                    that disabling cookies may affect access to
                    certain parts or features of our services.
                  </p>

                </div>

              </div>

            </article>


            {/* SECURITY */}
            <article
              id="security"
              className="bi-privacy-article"
            >

              <div className="bi-privacy-heading">
                <span>10</span>
                <h2>Data Security</h2>
              </div>

              <p>
                Best Industries is committed to safeguarding your
                data. We take reasonable precautions and use
                appropriate technologies and security practices
                to protect the information provided to us.
              </p>

              <p>
                Our efforts are focused on preventing unauthorized
                access, disclosure, misuse and data theft.
              </p>

              <div className="bi-security-box">

                <div className="bi-security-ring">
                  ✓
                </div>

                <div>

                  <strong>
                    YOUR DATA. OUR RESPONSIBILITY.
                  </strong>

                  <p>
                    We make reasonable efforts to protect the
                    information entrusted to Best Industries.
                  </p>

                </div>

              </div>

            </article>


            {/* CHILDREN */}
            <article
              id="children"
              className="bi-privacy-article"
            >

              <div className="bi-privacy-heading">
                <span>11</span>
                <h2>Children's Policy</h2>
              </div>

              <p>
                This website and its services are intended for
                adults.
              </p>

              <p>
                We do not knowingly accept, collect or use personal
                information from children under the age of 13.
              </p>

              <p>
                We kindly request that persons under the age of
                13 do not submit personal information through
                this website.
              </p>

              <div className="bi-children-warning">

                <div className="bi-children-age">
                  13
                </div>

                <div>
                  <strong>
                    AGE REQUIREMENT
                  </strong>

                  <span>
                    Users under 13 should not submit personal
                    information through this website.
                  </span>
                </div>

              </div>

            </article>


            {/* FINAL */}
            <div className="bi-privacy-final">

              <span>BEST INDUSTRIES</span>

              <h3>
                Your privacy.
                <strong> Our commitment.</strong>
              </h3>

              <p>
                Best Industries remains committed to protecting
                your information and maintaining a safe and
                trustworthy digital experience.
              </p>

            </div>

          </main>

        </div>

      </div>

    </section>
  );
};

export default PrivacyPolicy;
